import React, { useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import * as rstm from 'react-simple-tree-menu';
import Button from 'react-bootstrap/esm/Button';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { TreeActionModal } from './modals/TreeActionModal';

type TreeRowDeleteButtonProps = {
  variantTree: string;
  variantOperation: 'delete' | 'edit' | 'add';
  item: rstm.TreeMenuItem;
  onActionConfirmed: (id?: string) => void;
};

export const TreeRowActionButton: React.FC<TreeRowDeleteButtonProps> = ({
  variantTree,
  variantOperation,
  item,
  onActionConfirmed,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const ActionIcon =
    variantOperation === 'delete'
      ? Icon.Trash
      : variantOperation === 'edit'
      ? Icon.Pencil
      : Icon.PlusLg;
  const buttonVariant =
    variantOperation === 'delete' ? 'danger' : 'outline-light';

  const tooltip =
    variantOperation === 'delete'
      ? 'Usunięcie zaznaczonej wartości'
      : variantOperation === 'edit'
      ? 'Edycja zaznaczonej wartości'
      : 'Dodanie elementu pod zaznaczoną wartością';
  return (
    <>
      <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltip}</Tooltip>}>
        <Button
          className="ms-2"
          variant={buttonVariant}
          size="sm"
          onClick={e => {
            e.stopPropagation();
            setShow(true);
          }}
        >
          <ActionIcon />
        </Button>
      </OverlayTrigger>

      {show && (
        <TreeActionModal
          variantTree={variantTree}
          variantOperation={variantOperation}
          item={item}
          onAction={id => {
            setShow(false);
            onActionConfirmed(id);
          }}
          show={show}
          onClose={handleClose}
        />
      )}
    </>
  );
};
